import React, { useEffect, useState } from 'react';
import './ServiceDetails.css'
import { useParams } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../../../firebase.init';

const ServiceDetails = () => {
  const [user, loading, error] = useAuthState(auth);
  let stringID = useParams();
  const serviceId = parseInt(stringID.id)

  const [services, setServices] = useState([]);
  useEffect(()=>{
    fetch('../../services.json')
    .then(res => res.json())
    .then(services => setServices(services))
  },[]);

  const selectedService = services.find(service => service.id === serviceId);
  
  const handleShipping = e => {
    e.preventDefault();
    const name = e.target.name.value;
    alert(`Hello ${name}, thank you for the booking`)

  }
  return (
    <div className='service_details_page'>
      
      <div className="container">
        <div className="row">
        <div className="col-sm-5">
       <div className="single_service">
          <div className='service_banner'>
          <img className='img-fluid mt-3' src={selectedService?.img} alt={selectedService?.name} />
          </div>
         <div className="service_info">
           <h4>{selectedService?.name}</h4>
           <p>{selectedService?.name} Photo Session</p>
         </div>
         <h5><small>$</small>{selectedService?.price}</h5>
         <p>{selectedService?.desc}</p>
         </div>
       </div>
       <div className="col-sm-7">
         <div className="shipping_details">
           <h2 className='text-white'>Shipping Details</h2>
         <form onSubmit={handleShipping}>
  <div className="mb-3">
    <input readOnly value={user?.displayName} name='name' required type="text" className="form-control" placeholder='Your name'/>
  </div>
  <div className="mb-3">
    <input readOnly value={user?.email} type="email" className="form-control" placeholder='Your Email'/>
  </div>
  <div className="mb-3">
    <input required type="text" className="form-control" placeholder='Your phone'/>
  </div>
  <div className="mb-3">
    <input required type="text" className="form-control" placeholder='Address line 1'/>
  </div>
  <div className="mb-3">
    <input type="text" className="form-control" placeholder='Address line 2'/>
  </div>
  <button type="submit" className="btn btn-info mb-4 w-100">Submit details</button>
</form>
         </div>
       </div>
        </div>
        
      </div>

    </div>
  );
};

export default ServiceDetails;